import { render, staticRenderFns } from "./EditCase2.vue?vue&type=template&id=b51166aa&scoped=true&"
import script from "./EditCase2.vue?vue&type=script&lang=js&"
export * from "./EditCase2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51166aa",
  null
  
)

export default component.exports